const computed = {
  unsupportedBrowserDetected() {
    return this.isIE;
  },
  isIE() {
    const ua = window.navigator.userAgent;
    // Source: https://codepen.io/gapcode/pen/vEJNZN
    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // eslint-disable-next-line
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // eslint-disable-next-line
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return !Number.isNaN(Number.parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10));
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return !Number.isNaN(Number.parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10));
    }

    // Edge is fine - ETC
    // const edge = ua.indexOf('Edge/');
    // if (edge > 0) {
    //   // Edge (IE 12+) => return version number
    //   return Number.parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    // }

    // other browser
    return false;
  },
};

export default {
  computed,
};
